<template>
  <div class="loading-status-page">
    <div class="loading-status-wrapper">
      <img class="loading-gif" src="/assets/loading_img.gif" alt="로딩 gif" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingStatus'
}
</script>

<style scoped>
.loading-status-page {
  position: fixed;
  z-index: 9003;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background-color: rgba(0, 0, 0, 0.2);
}

.loading-status-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}

.loading-status-wrapper .loading-gif {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
}
</style>
